import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, DatePicker, Form, Input, Modal} from 'antd';
import dayjs from 'dayjs';

import {updateApiLink} from '@/api/clientApps';

const LocalApiAkskFormModal = forwardRef(({clientAppId, reload}, ref) => {
    const formRef = useRef();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [link, setLink] = useState({});

    function showModal(linkData) {
        // console.log('linkData', linkData);
        setVisible(true);

        const {apiDefine, applyDate, ...rest} = linkData;

        setLink({...rest, applyDate: applyDate ? dayjs(applyDate) : null});
    }

    function closeModal() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function onOk() {
        formRef.current.submit();
    }

    function onFinish(values) {
        console.log('Received values of form: ', values);
        const {applyDate, ...rest} = values;
        // console.log(applyDate);
        // console.log(applyDate instanceof dayjs);
        // console.log(applyDate.valueOf());
        // 转换日期时间为时间戳
        const formValues = {...rest, applyDate: applyDate?.valueOf()};
        console.log(formValues);

        setLoading(true);
        updateApiLink(clientAppId, formValues.id, formValues)
            .then(data => {
                console.log(data);
                reload();
                closeModal();
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            title="Aws AKSK 配置"
            onCancel={closeModal}
            onOk={onOk}
            confirmLoading={loading}
        >
            <Form ref={formRef} onFinish={onFinish} layout="vertical" initialValues={link}>
                <Form.Item hidden name="id">
                    <Input />
                </Form.Item>
                <Form.Item hidden name="apiId">
                    <Input />
                </Form.Item>
                <Form.Item hidden name="clientAppId">
                    <Input />
                </Form.Item>

                <Form.Item
                    name="awsAk"
                    label="AWS AK"
                    rules={[
                        {
                            required: true,
                            message: '请输入AWS AK',
                        },
                    ]}
                >
                    <Input placeholder="AWS AK" maxLength={100} />
                </Form.Item>
                <Form.Item
                    name="awsSk"
                    label="AWS SK"
                    rules={[
                        {
                            required: true,
                            message: '请输入AWS SK',
                        },
                    ]}
                >
                    <Input placeholder="AWS SK" maxLength={100} />
                </Form.Item>
                {/* todo: 由于与 moment 组件冲突，此处暂时屏蔽*/}
                <Form.Item
                    name="applyDate"
                    label="申请日期"
                    rules={[
                        {
                            required: true,
                            message: '请选择申请日期',
                        },
                    ]}
                >
                    <DatePicker inputReadOnly />
                </Form.Item>
                <Form.Item
                    name="reason"
                    label="申请原因"
                    rules={[
                        {
                            required: true,
                            message: '请输入申请原因',
                        },
                    ]}
                >
                    <Input placeholder="原因" maxLength={100} />
                </Form.Item>
                <Form.Item
                    name="person"
                    label="申请员工"
                    rules={[
                        {
                            required: true,
                            message: '申请原因',
                        },
                    ]}
                >
                    <Input placeholder="申请员工" maxLength={100} />
                </Form.Item>

                <Form.Item style={{display: 'none'}}>
                    <Button type="primary" htmlType="submit" />
                </Form.Item>
            </Form>
        </Modal>
    );
});

LocalApiAkskFormModal.displayName = 'LocalApiAkskFormModal';

LocalApiAkskFormModal.propTypes = {
    clientAppId: PropTypes.string.isRequired,
    reload: PropTypes.func.isRequired,
};

export default LocalApiAkskFormModal;
